// extracted by mini-css-extract-plugin
export default {"WidgetIcon":"CustomWidgetIcon_WidgetIcon__543w+"};